import { render, staticRenderFns } from "./PersonalDetailsActivity.vue?vue&type=template&id=3d8d02a2&scoped=true&"
import script from "./PersonalDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./PersonalDetailsActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=3d8d02a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d02a2",
  null
  
)

export default component.exports